import { Navigate, Route, Routes } from 'react-router-dom';
import { useErrorHandler } from 'react-error-boundary';
import { Layout } from 'layout';
import {
  RouteConfig,
  RouteEnum,
  authenticatedRoutes,
  instance,
  isCurrentLocationOneOf,
  unauthenticatedRoutes,
  useSession,
} from 'App';
import { Loader, PageNotFound, isUnauthorizedError, isAccessDenied, isBadRequest } from '@shared';

export function AppRoutes(): JSX.Element {
  const { authenticated, initializing, initialPage, unauthenticate } = useSession();
  const handleError = useErrorHandler();

  instance.interceptors.response.use(null, (error) => {
    if (isUnauthorizedError(error)) {
      const shouldRedirect = !isCurrentLocationOneOf([
        RouteEnum.Login,
        RouteEnum.Verification,
        '/',
      ]);
      if (shouldRedirect) {
        unauthenticate(false);
      }
    }
    if (isAccessDenied(error) || isBadRequest(error)) {
      handleError(error);
    }
    return Promise.reject(error);
  });

  if (initializing) {
    return <Loader />;
  }
  const routes = authenticated ? authenticatedRoutes : unauthenticatedRoutes;

  return (
    <Routes>
      <Route element={<Layout authenticated={authenticated} />}>
        {routes.map(({ label, component: Element, path }: RouteConfig) => (
          <Route key={label} element={<Element />} path={path} />
        ))}
        <Route
          key={-1}
          path='*'
          element={
            authenticated ? (
              <PageNotFound initialPage={initialPage} />
            ) : (
              <Navigate to={RouteEnum.Login} />
            )
          }
        />
        {authenticated && <Route path='/' element={<Navigate to={initialPage} />} />}
      </Route>
    </Routes>
  );
}
